import React from 'react'
import PlayerCancellationModal from '../components/PlayerCancellationModal'
import { apiGet } from '../utils/api'

export default function PlayerCancellations() {
  const [items, setItems] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState('')
  const [players, setPlayers] = React.useState<any[]>([])
  const [tournaments, setTournaments] = React.useState<any[]>([])
  const [editingId, setEditingId] = React.useState<string>('')
  const [open, setOpen] = React.useState(false)
  const [tournamentForModal, setTournamentForModal] = React.useState<any>(null)
  const [playerForModal, setPlayerForModal] = React.useState<string>('')

  const load = async () => {
    try {
      setLoading(true)
      const [data, dp, dt] = await Promise.all([
        apiGet<{ items?: any[] }>('/player-cancellations'),
        apiGet<{ players?: any[]; items?: any[] }>('/players?isActive=true&limit=1000'),
        apiGet<{ tournaments?: any[]; items?: any[] }>('/tournaments?limit=1000'),
      ])
      const arr = Array.isArray(data?.items) ? data.items : []
      setItems(arr)
      setPlayers(dp.players || dp.items || [])
      setTournaments(dt.tournaments || dt.items || [])
    } catch (e:any) {
      setError(e?.message || 'Ошибка загрузки')
    } finally { setLoading(false) }
  }

  React.useEffect(() => { load() }, [])

  const findTournament = (id?: string) => (tournaments || []).find((t:any)=> t.id===id) || null
  const playerName = (id?: string) => (players || []).find((p:any)=> p.id===id)?.name || id

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">Отмены участий</h1>
        <button onClick={load} className="px-3 py-2 text-sm border rounded">Обновить</button>
      </div>
      {error && <div className="text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded text-sm">{error}</div>}
      <div className="bg-white border rounded">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-600">
            <tr>
              <th className="text-left px-3 py-2">Дата</th>
              <th className="text-left px-3 py-2">Игрок</th>
              <th className="text-left px-3 py-2">Турнир</th>
              <th className="text-left px-3 py-2">Уровень</th>
              <th className="text-right px-3 py-2">Сумма</th>
              <th className="text-left px-3 py-2">Причина</th>
              <th className="text-left px-3 py-2">Комментарий</th>
              <th className="text-right px-3 py-2">Действия</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} className="px-3 py-4 text-center text-gray-500">Загрузка...</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan={8} className="px-3 py-6 text-center text-gray-500">Нет документов</td></tr>
            ) : (
              items.map((it:any) => (
                <tr key={it.id} className="border-t">
                  <td className="px-3 py-2">{String(it.createdAt || '').slice(0,10)}</td>
                  <td className="px-3 py-2">{playerName(it.playerId)}</td>
                  <td className="px-3 py-2">{findTournament(it.tournamentId)?.name || it.tournamentId || '—'}</td>
                  <td className="px-3 py-2">{it.level || '—'}</td>
                  <td className="px-3 py-2 text-right">{Number(it.amount||0).toFixed(2)}</td>
                  <td className="px-3 py-2">{it.reason || '—'}</td>
                  <td className="px-3 py-2">{it.comment || '—'}</td>
                  <td className="px-3 py-2 text-right">
                    <button
                      className="text-blue-600 hover:underline mr-3"
                      onClick={() => { setEditingId(it.id); setTournamentForModal(findTournament(it.tournamentId)); setPlayerForModal(it.playerId); setOpen(true) }}
                    >Редактировать</button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      {open && tournamentForModal && (
        <PlayerCancellationModal
          tournament={tournamentForModal}
          players={players}
          isOpen={open}
          editingId={editingId}
          prefillPlayerId={playerForModal}
          onClose={() => { setOpen(false); setEditingId(''); setPlayerForModal(''); setTournamentForModal(null) }}
          onSuccess={() => { setOpen(false); setEditingId(''); load() }}
        />
      )}
    </div>
  )
}


